const contextFactory = (
    App,
    reducers,
    rootSaga,
    history,
    restClient,
    micrositeParams,
    middlewares = [],
    loggerFactory
) => ({
    App,
    reducers,
    rootSaga,
    history,
    restClient,
    micrositeParams,
    middlewares,
    loggerFactory,
});

export default contextFactory;
